// ==========================
// Version 3 — MapAndStrip.js (responsive grid class)
// ==========================
import React from 'react';
import UserMap from './UserMap';
import MiniTimelineStrip from './MiniTimelineStrip';

function MapAndStrip({ userId, memories = [] }) {
  const [activeId, setActiveId] = React.useState(null);

  React.useEffect(() => {
    if (!memories?.length) { setActiveId(null); return; }
    const newest = [...memories].sort(
      (a, b) => String(b.date || '').localeCompare(String(a.date || ''))
    )[0];
    setActiveId(newest.firestoreId || newest.id);
  }, [memories]);

  return (
    <div className="map-strip">
      <UserMap userId={userId} activeId={activeId} onActiveChange={setActiveId} />
      <MiniTimelineStrip memories={memories} activeId={activeId} onActiveChange={setActiveId} />
    </div>
  );
}

export default MapAndStrip;
// ==========================
// End Version 3 — MapAndStrip.js
// ==========================
